<template>
  <div :class="['vuetable-pagination-info', css.infoClass]"
    v-html="paginationInfo">
  </div>
</template>

<script>
import PaginationInfoMixin from 'vuetable-2/src/components/VuetablePaginationInfoMixin.vue'

export default {
  mixins: [PaginationInfoMixin],
  props: ['info-template', 'info-class', 'no-data-template']
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PaginationInfo.vue